<template>
	<section class='knd-map m-b-md'>

		<div class='knd-map__content'>

			<div class='container-map' ref='chart'>

				<div class='reset-map knd-text-sm' v-show="showReset">
					<div v-on:click="onZoomOut">
						zoom uit
					</div>
				</div>
				
				<div class='scroll-overlay' ref='overlay'>
					<div class='scroll-overlay_hint'>
						{{overlayText}}
					</div>
				</div>

				<!-- Tooltip -->
				<div class='knd-tooltip' ref='tooltip' v-show="highlight" 
					v-bind:style="{ 'left': tooltipXpos +'px', 'top': tooltipYpos +'px'}">
					<div v-if="highlight">
						<div class='knd-tooltip__title'>
							<span v-if="highlight.WK_NAAM">{{highlight.WK_NAAM}},</span>
							{{highlight.GM_NAAM}}
						</div>

						<div 
							class='knd-tooltip__info knd-tooltip__woningcorperatiebezit' 
							v-if="highlight.overgewicht && (key=== 'OVERGEWICHT' || key=== 'BIVARIATE') ">
							<span>Overgewicht: </span>
							{{highlight.overgewicht}}% 
					</div>

						<div class='knd-tooltip__info knd-tooltip__energiearmoede'
							v-if="highlight.opleiding && (key=== 'OPLEIDING' || key=== 'BIVARIATE')">
							<span>Laag opgeleid:</span>
							{{highlight.opleiding}}%
						</div>

						<div 
							class='knd-tooltip__info' 
							v-if="!highlight.overgewicht && !highlight.opleid">
								Buurtgegevens onbekend
						</div>


						<div class='knd-tooltip__info knd_tooltip__zoomin_label ta-center' v-if="!highlight.WK_NAAM">
							klik om per buurt te bekijken
						</div>
					</div>
					</div>
			</div>

			<div class='container-scatterplot' ref='scatterplot'></div>

		</div>
		<div class='knd-source knd-source-abs knd-text-sm'>
			<small>
				<span v-if="key === 'OVERGEWICHT'">Bron: <a href='https://statline.rivm.nl/portal.html?_la=nl&_catalog=RIVM&tableId=50090NED&_theme=85' target='_blank'>Gezondheidsmonitor 2020</a>, RIVM</span>
			<span v-if="key === 'OPLEIDING'">Bron: <a href='https://opendata.cbs.nl/portal.html?_la=nl&_catalog=CBS&tableId=84583NED&_theme=234 target=_blank'>Kerncijfers wijken en buurten 2019</a>, CBS</span>
			<span v-if="key === 'SCATTERPLOT_START' || key ===  'SCATTERPLOT' || key === 'XAXIS' || key === 'SEARCH'">Bron: Gezondheidsmonitor 2020, RIVM | Kerncijfers wijken en buurten 2019, CBS</span>
		</small>
		</div>
	</section>
</template>

<script>
	import debounce from './debounce';
	import { select } from 'd3-selection';
	import {scaleThreshold} from 'd3-scale';

	import * as topojson from 'topojson';
	
	import MapChart from './map';
	import Scatterplot from './scatterplot';
	import './kaart.scss';

	const d3 = {
		select,
		scaleThreshold
	}

	const vueObject = {
		props: ['data'],
		computed: {
			gmCode() {
				return this.$store.getters.gmCode;
			},

			buurtCode() {
				return this.$store.getters.buurtCode;
			},

			step() {
				return this.$store.getters.step;
			}
		},
		watch: {
			gmCode(newValue, oldValue) {
				if(newValue && newValue !== oldValue) {
					// do stuff
					this.scatterplot.fadeInGemeente(newValue);
					this.scatterplot.highlightNone();
					// console.log(newValue);
				}
			},

			buurtCode(newValue, oldValue) {
				if(newValue && newValue !== oldValue) {
					// do stuff
					this.scatterplot.highlightBuurt(this.gmCode, newValue);
				}
			},

			step(newValue, oldValue) {
				if(newValue && newValue !== oldValue) {

					this.renderStep(newValue);
				}
			}

		},

		mounted: function() {
			this.renderChart();
			// this.$refs.chart.style.display = "none";
			this.renderScatterplot();

			let desktop = 'Gebruik shift + scrollen om in en uit te zoomen op de kaart';
			let mobile = 'Gebruik twee vingers om de kaart te verplaatsen';

			this.overlayText = this.isMobile() ? mobile : desktop;
		},
		data: function() {
			return {
				highlight: {},
				tooltipXpos: 10,
				tooltipYpos: 300,
				showReset: false,
				overlayText: '',
				key: undefined,
				domains: {
					"overgewicht": [38, 45, 50, 53, 57, 70],
					"opleiding": [6, 16, 23, 31, 44, 88]
				}				
			}
		},
		methods: {
			isMobile() {
				if (('ontouchstart' in window) ||
						(navigator.maxTouchPoints > 0) ||
						(navigator.msMaxTouchPoints > 0)) {
							/* browser with either Touch Events of Pointer Events
								 running on touch-capable device */
					return true;
				}
				return false;
			},

			closeIntro() {
				this.$refs.intro.classList.add('hide');
			},

			zoominGemeente(gmCode) {
				this.chart.zoomIn(gmCode);

				document.activeElement.blur();
			},	

			resetSearch() {
				// this.inputGemeente.value = '';
			},

			onZoomOut() {
				this.chart.resetZoom();
			},

			renderStep(step) {
				this.chart.resetHighlight();
				this.hideTooltip();

				if(step.highlight) {
					let arrHighlight = step.highlight.split(',');
					
					for(var i = 0; i < arrHighlight.length; i++) {
						this.chart.highlight(arrHighlight[i]);
					}
				}

				switch(step.zoom) {
					case 'OVERVIEW':
						// do stuff
						if(this.showReset) {
							this.onZoomOut();
						}
						break;
					default:
						if(step.zoom) {
							this.zoominGemeente(step.zoom);
						}
						// do stuff
						break;
				}

				switch(step.key) {
					case 'OVERGEWICHT':
						// do stuff
						if(this.key === 'OVERGEWICHT') return;

						//scaleThreshold([38, 45, 50, 53, 57, 70] 
						this.chart.renderMono({
							scale: d3.scaleThreshold,
							value: d => { return d.properties.overgewicht},
							range: ['#FFF8F8', '#FFE3E1', '#FFCAC6', '#FFB7B1', '#FF9A92','#FF7469'],
							title: 'Overgewicht in %',
							domain: [38, 45, 50, 53, 57, 70]
						})
						// this.$refs.chart.style.display = "block";
						this.toggleMap(false);
						break;
					case 'OPLEIDING': 
						if(this.key === 'OPLEIDING') return;
						this.chart.renderMono({
							scale: d3.scaleThreshold,
							range: ['#F3EEFF', '#D7C8FF', '#BFA7FF', '#AB8CFF', '#9A75FF','#8456FF'],							
							value: d => { 
								if(d.properties.opleiding > 100) return 0; 
								return +d.properties.opleiding
							},
							title: 'Lage opleiding in %',
							domain: [6, 16, 23, 31, 44, 88]
						})
						// this.$refs.chart.style.display = "block";
						this.toggleMap(false);
						break;
					case 'SCATTERPLOT_START':
						this.toggleMap(true);
						// this.scatterplot.buildXAxis();
						// this.scatterplot.highlightNone();
						// this.scatterplot.fadeInNone();
						this.scatterplot.render();
						this.scatterplot.buildBothAxes();			

						break;
					case 'SCATTERPLOT':
						this.toggleMap(true);
						// this.scatterplot.fadeInStedelijk();
						this.scatterplot.render();
						this.scatterplot.draw();

						break;
					case 'XAXIS':
						this.toggleMap(true);
						this.scatterplot.render();
						this.scatterplot.draw();
						// this.scatterplot.buildXAxis();

						break;
					case 'SEARCH':
						this.toggleMap(true);
						this.scatterplot.render();
						this.scatterplot.highlightBuurt(this.gmCode, this.buurtCode);
						break;
					case 'REGRESSION':
						this.toggleMap(true);
						// debugger;
						// this.scatterplot.highlightNone();
						this.scatterplot.render();
						this.scatterplot.draw();
						this.scatterplot.drawRegressionLine({"stedelijkheid": true});

						break;
				}

				this.key = step.key;
			},

			toggleMap(hide){
				let $sel = d3.select(this.$refs.chart);
				if(hide) {
					$sel.transition().duration(500).style('opacity', 0).style('height', '0px')
				} else {
					$sel.transition().duration(500).style('opacity', 1).style('height', 'inherit')
				}
			},

			renderChart() {
				var NLgeo = topojson.feature(this.data, this.data.objects.wijk);
				var NLGemeente = topojson.feature(this.data, this.data.objects.gemeente);

				this.chart = new MapChart()
					.container(this.$refs.chart)
					.data([NLgeo, NLGemeente])
					.margin({top: 10, right: 30, bottom: 30, left: 30})
					.height(true)
					.width(true)
					.onMouseOver((d, x, y) => this.showTooltip(d, x, y))
					.onMouseOut(d => this.hideTooltip())
					.onResetSearch(() => this.resetSearch())
					.onShowReset((bool) => this.showResetBtn(bool))

					.render();

				this.renderStep({key: 'OVERGEWICHT'})
			},

			renderScatterplot() {
				var NLgeo = topojson.feature(this.data, this.data.objects.wijk);

				this.scatterplot = new Scatterplot()
					.container(this.$refs.scatterplot)
					.data(NLgeo.features)
					.colordomains(this.domains)
					.margin({top: 10, right: 10, bottom: 30, left: 30})
					.height(true)
					.width(true)
					.responsive(true)
					.setup()

				// this.scatterplot.logData();
			},

			renderLegendIntro() {
				let legendContent = this.chart.legend('intro');
				const xPosLegend = this.chart.width() < 400 ? 75 : 150;

				this.legend = d3.select('.knd-intro__legend_g')
					.attr('class', `knd-legend` )
					.attr("transform", "translate("+ 100 +"," + 75 + ")")
					.html(legendContent);
			},

			showTooltip(d, xPos, yPos) {
				// if(this.key !== 'FREEMODE') return;

				this.highlight = d;

				this.$refs.tooltip.classList.add('show');

				let padding = 15;
				let tooltipWidth = this.$refs.tooltip ? this.$refs.tooltip.offsetWidth : 0;
				let tooltipHeight = this.$refs.tooltip ? this.$refs.tooltip.offsetHeight : 0;

				let top = window.innerHeight > yPos + tooltipHeight + padding
					? yPos + padding
					: yPos - tooltipHeight - padding;


				this.tooltipYpos = top;
				this.tooltipXpos = xPos - (tooltipWidth /2);
			},

			hideTooltip() {
				this.$refs.tooltip.classList.remove('show');
				this.highlight = null;
			},

			showResetBtn(bool) {
				this.showReset = bool;
			}
		}
	}

	export default vueObject;

</script>

